import React from 'react'

import { FallbackImage } from './FallbackImage'
import { PrimaryAssetImage } from './PrimaryAssetImage'

export const AssetImage: React.FC<{
  primaryImageID: string | undefined
  assetModelType?: string
  showThumbnail?: boolean
  onImageLoadStatus?: (isLoaded: boolean) => void
}> = ({
  primaryImageID,
  assetModelType,
  showThumbnail = true,
  onImageLoadStatus,
}) => {
  return primaryImageID ? (
    <PrimaryAssetImage
      primaryImageID={primaryImageID}
      assetModelType={assetModelType}
      showThumbnail={showThumbnail}
      onImageLoadStatus={onImageLoadStatus}
    />
  ) : (
    <FallbackImage
      assetModelType={assetModelType}
      showThumbnail={showThumbnail}
    />
  )
}
